import {FilterCategory, FilterCategoryType, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {FilterDropdown} from "@/components/filterDropdown/FilterDropdown.tsx";
import {GQL_MAINTENANCE_SERVICES_FILTER_LIST} from "@/lib/queries/maintenance.ts";

type ActiveOccurrencesFiltersProps = {
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
};

export const ActiveOccurrencesFilters = ({filterSets, onFilterSetChange}: ActiveOccurrencesFiltersProps) => {
  const filterFields: FilterCategory[] = [
    {
      key: "services",
      type: FilterCategoryType.GQL,
      display: "Checks",
      graphql: GQL_MAINTENANCE_SERVICES_FILTER_LIST,
      sorted: true,
    },
  ];

  return <FilterDropdown categories={filterFields} appliedFilterSets={filterSets} onApply={onFilterSetChange} />;
};
